module.exports = __webpack_public_path__ + "static/media/oseberg_full_text_search_logo_only-01.3cb3076a.svg";